var variant_id = "";
var selling_plan_id = "";
let mervRating = "MERV 11";
let packSize = document.querySelector('#current_pack').value;
var variant_price = "";

document.getElementById("width-drop").addEventListener("change", fetchproduct);
document.getElementById("current_pack").addEventListener("change", updatePack);
document.getElementById("current_pack").addEventListener("change", availvariants);
document.getElementById("addcart").addEventListener("click", addcart);
document.getElementById("length-drop").addEventListener("change", updateSize);
document.getElementById("width-drop").addEventListener("change", updateSize);
document.getElementById("height-drop").addEventListener("change", updateSize);
document.getElementById("width-drop").addEventListener("change", updateDiscountTab);
document.getElementById("sellingplandrop").addEventListener("change", updateSellingPlan);
document.getElementById("sellingplandrop").addEventListener("change", updateSellingPlans);
document.getElementById("subatc").addEventListener("click", updateSellingPlan);
document.getElementById("subatc").addEventListener("click", updateSellingPlans);
document.getElementById("subatc").addEventListener("click", fetchproduct);
document.getElementById("normalatc").addEventListener("click", fetchproduct);
const mervRatings = document.querySelectorAll('input.merv--rating');
document.getElementById("merv6con").addEventListener("click", clickmerv6);
document.getElementById("merv8con").addEventListener("click", clickmerv8);
document.getElementById("merv11con").addEventListener("click", clickmerv11);
document.getElementById("merv13con").addEventListener("click", clickmerv13);
document.getElementById("carboncon").addEventListener("click", clickcarbon);
document.getElementById("length-drop").addEventListener("click", remove20);
document.getElementById("length-drop").addEventListener("change", updateSellingPlans);
document.getElementById("width-drop").addEventListener("change", updateSellingPlans);
document.getElementById("width-drop").addEventListener("change", testfs);
document.getElementById("height-drop").addEventListener("change", updateSellingPlans);
document.getElementById("subatc").addEventListener("click", updateSellingplandefault);
function testfs(){
          document.getElementById("oos").hidden = false;
          document.getElementById("addcart").disabled = true;
}

function updateSellingplandefault(){
  
  updateSellingPlans();
  document.getElementById("sellingplandrop").selectedIndex = 2;

  updateSellingPlan();
}
mervRatings.forEach(rating => {
  rating.addEventListener("click", function(event) {
    const clickedValue = event.target.value;
    mervRating = clickedValue;
    fetchproduct();
    updateDiscountTab();
    updateSellingPlan();
    updateSellingPlans();
    return mervRating;
   

  });
});

function remove20(){
  if (document.querySelector('.zero-option').lenght > 0){
  document.querySelector('.zero-option').remove();

  }


}
function updatedcpack(){

  document.getElementById('dcpacksize').innerText = packSize;
}
function clickmerv6(){
  document.querySelector('input.merv--rating[value="MERV 6"]').click();
  updatePack();
  updateDiscountTab();
}
function clickmerv8(){
  document.querySelector('input.merv--rating[value="MERV 8"]').click();
  updatePack();
}
function clickmerv11(){
  document.querySelector('input.merv--rating[value="MERV 11"]').click();
  updatePack();
}
function clickmerv13(){
  document.querySelector('input.merv--rating[value="MERV 13"]').click();
  updatePack();
}
function clickcarbon(){
  document.querySelector('input.merv--rating[value="MERV 11 + Carbon"]').click();
  updatePack();
}
function updateSellingPlan(){

    var selectElement = document.getElementById("sellingplandrop");
    var selectedIndex = selectElement.selectedIndex;
    var selectedOption = selectElement.options[selectedIndex];
    var selectedValue = selectedOption.value;
    selling_plan_id = selectedValue;
    console.log(selling_plan_id);
    return selling_plan_id;

}
function updateSize(){
  document.getElementById("sellingplandrop").selectedIndex = 2;
  var short = document.querySelector('#length-drop');
    var long = document.querySelector('#height-drop');
    var width = document.querySelector('#width-drop');
    var productHandle = short.value + "x" + long.value + "x" + width.value;
    
    if (long.length > 1){
      document.getElementById("discount__size").innerHTML = productHandle;
    }
    else{
      document.getElementById("discount__size").innerHTML = "";
      document.getElementById("addcart").disabled = true;
    }
    document.getElementById("normalatc").checked = "true";
    availvariants();
    
    updateSellingPlans();
    updateSellingPlan();

}
function fetchproduct() {
    var short = document.querySelector('#length-drop');
    var long = document.querySelector('#height-drop');
    var width = document.querySelector('#width-drop');
    
    var productHandle = short.value + "x" + long.value + "x" + width.value;
    productHandle = productHandle.replace(/\s+/g, '-');
    productHandle = productHandle.replace(/\//g, '-');
    if (productHandle == "16-3-8x21-1-2x1" || productHandle == "13x21-1-2x1" || productHandle == "19-7-8x21-1-2x1" || productHandle == "21-1-2x23-5-16x1"){
          
      productHandle += "-carrier-replacement-filter-by-aerostar";
      console.log(productHandle);
    }

else if( productHandle == "17x27x5" || productHandle == "21x26x5"){

productHandle += "-trane-deep-pleat-air-filter";
}
else if( productHandle == "19x20x4"){

productHandle += "-carrier-deep-pleat-air-filter"; }    else if(productHandle == "16x20x4" || productHandle == "16x24x4" || productHandle == "18x24x4" || productHandle == "20x24x4" || productHandle == "20x25x4" || productHandle == "24x24x4" ){  productHandle += "-commercial-hvac-filter"; }        else if(productHandle == "16x20x5"){  productHandle += "-honeywell-deep-pleat-air-filter";
}


    else {

      productHandle += "-air-filter";
      console.log(productHandle);
    }
    $.ajax({
        url: `${shopifyStoreUrl}/api/2024-10/graphql.json`,  // Replace with your Shopify store's URL
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
            query: `
                {
                    product(handle: "` + productHandle + `") {
                        variantBySelectedOptions(selectedOptions: [
                            { name: "MERV Rating", value: "` + mervRating + `" },
                            { name: "Pack Size", value: "` + packSize + `" }
                        ]) {
                            id
                            title
                            priceV2 {
                                amount
                                currencyCode
                            }
                        }
                    }
                }
            `,
        }),
           headers: {
                    'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                },
        success: function(response) {
        if (response.data.product.variantBySelectedOptions == null){
          document.getElementById("oos").hidden = false;
          document.getElementById("addcart").disabled = true;
          clickmerv11();
          
        }
        else{
          document.getElementById("oos").hidden = true;
          document.getElementById("addcart").disabled = false;
    
          var variantId = response.data.product.variantBySelectedOptions.id;
          var variant_price = Number(response.data.product.variantBySelectedOptions.priceV2.amount);
          variant_id = variantId.split('/').pop();
          if (document.getElementById('subatc').checked){
            variant_price = variant_price * 0.92;
            document.getElementById("addcart").innerText = "Add to Cart - $" + variant_price.toFixed(2);
          }
         else{
          document.getElementById("addcart").innerText = "Add to Cart - $" + variant_price.toFixed(2);
         }
          var tabprice = Number(variant_price / document.getElementById("current_pack").value);
          document.getElementById("eachprice").innerText = "$" + tabprice.toFixed(2) + " each";
    
          return variant_id,variant_price;
         
        }
          
        },
        error: function(error) {
            console.error('Error occurred:', error);
        }
    });
    
    
    }

    function addcart() {
      if(document.getElementById('normalatc').checked) {
        let formData = {
          'items': [{
           'id': variant_id,
           'quantity': 1
           }]
         };
            
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
        
      })
      .catch((error) => {
        console.error('Error:', error);
      });
      
      document.getElementById('addcart').disabled = true;
      document.getElementById('addcart').innerText = "Added to Cart!";
      
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true })); 
        document.dispatchEvent(new CustomEvent('cart:update ', {bubbles: true })); 
      }, 1000);

       
      setTimeout(() => {
        fetchproduct();
      }, 2000);
      
      }else if(document.getElementById('subatc').checked) {

        let formData = {
          'items': [{
           'id': variant_id,
           'quantity': 1,
           'selling_plan': selling_plan_id
           }]
         };
   
         fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
          
        })
        .catch((error) => {
          console.error('Error:', error);
        });
        
        document.getElementById('addcart').disabled = true;
      document.getElementById('addcart').innerText = "Added to Cart!";
    
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true })); 
          document.dispatchEvent(new CustomEvent('cart:update ', {bubbles: true })); 
        }, 1000);
        setTimeout(() => {
          fetchproduct();
        }, 2000);
      }

   
      }
      
      function updatePack() {
      
        packSize = document.querySelector('#current_pack').value;
        fetchproduct();
        updateDiscountTab();
        updatedcpack();
      }

      window.onload = function() {

        setTimeout(() => {
          fetchproduct();
          document.getElementById("addcart").disabled = false;
          updatedcpack();
          availvariants();
          updateDiscountTab();
          
          updateSellingPlans();
          updateSellingPlan();
        }, 1000);
       
      };
      function testfunction(){
        $.ajax({
          url: `${shopifyStoreUrl}/api/2024-10/graphql.json`,  // Replace with your Shopify store's URL
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
              query: `
                  {
                                product(handle: "12x12x1-air-filter") {
                                          variants(first: 30) {
                                            edges {
                                              node {
                                                id
                                                title
                                                sellingPlanAllocations(first: 5) {
                                                  edges {
                                                    node {
                                                      sellingPlan{
                                                        id
                                                        name
                                                        options{
                                                          name
                                                          value
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                  }
              `,
          }),
             headers: {
                      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                  },
          success: function(response) {
           let deliver3 = document.getElementById('deliver3');
           let deliver6 = document.getElementById('deliver6');
           let deliver12 = document.getElementById('deliver12');
            const products = response.data.product.variants.edges[0].node.sellingPlanAllocations.edges;
            products.forEach(function (product) {
                var selling_plan_id_update = product.node.sellingPlan.id.split('/').pop();

                
           if (product.node.sellingPlan.name == "Delivery every 3 Months"){
            deliver3.value = selling_plan_id_update;
 
           }
           if (product.node.sellingPlan.name == "Delivery every 6 Months"){
            deliver6.value = selling_plan_id_update;
  
           }
           if (product.node.sellingPlan.name == "Delivery every 12 Months"){
            deliver12.value = selling_plan_id_update;
    
           }

             });



                },
          error: function(error) {
          
          }
      });


      }

    

      function updateSellingPlans(){
        var short = document.querySelector('#length-drop');
        var long = document.querySelector('#height-drop');
        var width = document.querySelector('#width-drop');
       
        var productHandle = short.value + "x" + long.value + "x" + width.value;
        productHandle = productHandle.replace(/\s+/g, '-');
        productHandle = productHandle.replace(/\//g, '-');
        if (productHandle == "16-3-8x21-1-2x1" || productHandle == "13x21-1-2x1" || productHandle == "19-7-8x21-1-2x1" || productHandle == "21-1-2x23-5-16x1"){
          
          productHandle += "-carrier-replacement-filter-by-aerostar";
          console.log(productHandle);
        }

else if( productHandle == "17x27x5" || productHandle == "21x26x5"){

 productHandle += "-trane-deep-pleat-air-filter";
}
else if( productHandle == "19x20x4"){

 productHandle += "-carrier-deep-pleat-air-filter"; }    else if(productHandle == "16x20x4" || productHandle == "16x24x4" || productHandle == "18x24x4" || productHandle == "20x24x4" || productHandle == "20x25x4" || productHandle == "24x24x4" ){  productHandle += "-commercial-hvac-filter"; }        else if(productHandle == "16x20x5"){  productHandle += "-honeywell-deep-pleat-air-filter";
}
        else {
  
          productHandle += "-air-filter";
          console.log(productHandle);
        }

        $.ajax({
          url: `${shopifyStoreUrl}/api/2024-10/graphql.json`,  // Replace with your Shopify store's URL
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
              query: `
                  {
                                product(handle: "` + productHandle + `") {
                                          variants(first: 30) {
                                            edges {
                                              node {
                                                id
                                                title
                                                sellingPlanAllocations(first: 5) {
                                                  edges {
                                                    node {
                                                      sellingPlan{
                                                        id
                                                        name
                                                        options{
                                                          name
                                                          value
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                  }
              `,
          }),
             headers: {
                      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                  },
          success: function(response) {
            let deliver3 = document.getElementById('deliver3');
            let deliver6 = document.getElementById('deliver6');
            let deliver12 = document.getElementById('deliver12');
            deliver3.value = "";
            deliver6.value = "";
            deliver12.value = "";
            deliver3.style.display = "none";
            deliver6.style.display = "none";
            deliver12.style.display = "none";
           
            const products = response.data.product.variants.edges[0].node.sellingPlanAllocations.edges;
            products.forEach(function (product) {
              var selling_plan_id_update = product.node.sellingPlan.id.split('/').pop();

                
              if (product.node.sellingPlan.name == "Delivery every 3 Months"){
               deliver3.value = selling_plan_id_update;
               deliver3.style.display = "block";
              }
              if (product.node.sellingPlan.name == "Delivery every 6 Months"){
               deliver6.value = selling_plan_id_update;
               deliver6.style.display = "block";
              }
              if (product.node.sellingPlan.name == "Delivery every 12 Months"){
               deliver12.value = selling_plan_id_update;
               deliver12.style.display = "block";
              }

             });



                },
          error: function(error) {
          
          }
      });


      }


      function updateDiscountTab(){
        var short = document.querySelector('#length-drop');
        var long = document.querySelector('#height-drop');
        var width = document.querySelector('#width-drop');
        var productHandle = short.value + "x" + long.value + "x" + width.value;
        productHandle = productHandle.replace(/\s+/g, '-');
        productHandle = productHandle.replace(/\//g, '-');
        if (productHandle == "16-3-8x21-1-2x1" || productHandle == "13x21-1-2x1" || productHandle == "19-7-8x21-1-2x1" || productHandle == "21-1-2x23-5-16x1"){
          
          productHandle += "-carrier-replacement-filter-by-aerostar";
          console.log(productHandle);
        }

          else if( productHandle == "17x27x5" || productHandle == "21x26x5"){

          productHandle += "-trane-deep-pleat-air-filter";
          }
          else if( productHandle == "19x20x4"){

          productHandle += "-carrier-deep-pleat-air-filter"; }    else if(productHandle == "16x20x4" || productHandle == "16x24x4" || productHandle == "18x24x4" || productHandle == "20x24x4" || productHandle == "20x25x4" || productHandle == "24x24x4" ){  productHandle += "-commercial-hvac-filter"; }        else if(productHandle == "16x20x5"){  productHandle += "-honeywell-deep-pleat-air-filter";
          }
        else {
  
          productHandle += "-air-filter";
          console.log(productHandle);
        }
     
        $.ajax({
          url: `${shopifyStoreUrl}/api/2024-10/graphql.json`,  // Replace with your Shopify store's URL
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
              query: `
                  {
                      product(handle: "` + productHandle + `") {
                                  title
                                  variants(first: 30) {
                                    edges {
                                      node {
                                        id
                                        title
                                        priceV2{
                                        amount
                                        }
                                        availableForSale
                                        selectedOptions {
                                          name
                                          value
                                        }                            
                                      }
                                    }
                                  }
                                }
                  }
              `,
          }),
             headers: {
                      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                  },
          success: function(response) {

            document.querySelector('.size-discount__item--count').innerHTML =  '';
            document.querySelector('.size-discount__item--unit_price').innerHTML =  '';
            document.querySelector('.size-discount__item--save').innerHTML =  '';
            const products = response.data.product.variants.edges;
       
            var origprice = 0;

            products.forEach(function (product) {
                if (product.node.selectedOptions[0].value == mervRating){
                  if (product.node.selectedOptions[1].value == '2'){
                            origprice = product.node.priceV2.amount;
                       
                            return origprice;
                  }
               }

            
              });
              let pack2size =[];
              let pack2value =[];
              let pack2savings =[];
              let pack4size =[];
              let pack4value =[];
              let pack4savings =[];
              let pack6value =[];
              let pack6savings =[];
              let pack6size =[];
              let pack12size =[];
              let pack12value =[];
              let pack12savings =[];
                
                 products.forEach(function (product) {

                  if (product.node.selectedOptions[0].value == mervRating){
            
                   
                    var productvariant = product.node.priceV2.amount;
                    var productpacksize = product.node.selectedOptions[1].value;
                    var perpiece = productvariant/productpacksize;
                    var savingsamount = (origprice/2) - perpiece;
                    var savingspercent = (savingsamount/(origprice/2))*100;
                    if (productpacksize == '2'){
                          pack2size.push('<span>' + productpacksize + ' for </span><br>');
                          pack2value.push('<span>$' + perpiece.toFixed(2) + ' ea </span>');
                          if (savingspercent == 0 || savingspercent < 0){
                            pack2savings.push('<span></span><br>');

                          }
                          else{
                            pack2savings.push('<span> Save ' + savingspercent.toFixed(2) + '%</span><br>');
                          }

                    }

                  else if(productpacksize == '4'){
                    pack4size.push('<span>' + productpacksize + ' for </span><br>');
                    pack4value.push('<span>$' + perpiece.toFixed(2) + ' ea </span>');
                    if (savingspercent == 0 || savingspercent < 0){
                      pack4savings.push('<span></span><br>');

                    }
                    else{
                      pack4savings.push('<span> Save ' + savingspercent.toFixed(2) + '%</span><br>');
                    }


                  }
                  else if(productpacksize == '6'){
                    pack6size.push('<span>' + productpacksize + ' for </span><br>');
                    pack6value.push('<span>$' + perpiece.toFixed(2) + ' ea </span>');
                    if (savingspercent == 0 || savingspercent < 0){
                      pack6savings.push('<span></span><br>');

                    }
                    else{
                      pack6savings.push('<span> Save ' + savingspercent.toFixed(2) + '%</span><br>');
                    }


                  }
                  else if(productpacksize == '12'){
                    pack12size.push('<span>' + productpacksize + ' for </span><br>');
                    pack12value.push('<span>$' + perpiece.toFixed(2) + ' ea </span>');
                    if (savingspercent == 0 || savingspercent < 0){
                      pack12savings.push('<span></span><br>');

                    }
                    else{
                      pack12savings.push('<span> Save ' + savingspercent.toFixed(2) + '%</span><br>');
                    }


                  }
                  }
                       
                 });
                 document.querySelector('.size-discount__item--count').innerHTML += pack2size.join('');
                 document.querySelector('.size-discount__item--unit_price').innerHTML += pack2value.join('');
                 document.querySelector('.size-discount__item--save').innerHTML += pack2savings.join('');

                 document.querySelector('.size-discount__item--count').innerHTML += pack4size.join('');
                 document.querySelector('.size-discount__item--unit_price').innerHTML += pack4value.join('');
                 document.querySelector('.size-discount__item--save').innerHTML += pack4savings.join('');

                 document.querySelector('.size-discount__item--count').innerHTML += pack6size.join('');
                 document.querySelector('.size-discount__item--unit_price').innerHTML += pack6value.join('');
                 document.querySelector('.size-discount__item--save').innerHTML += pack6savings.join('');

                 document.querySelector('.size-discount__item--count').innerHTML += pack12size.join('');
                 document.querySelector('.size-discount__item--unit_price').innerHTML += pack12value.join('');
                 document.querySelector('.size-discount__item--save').innerHTML += pack12savings.join('');
                },
          error: function(error) {
            document.querySelector('.size-discount__item--count').innerHTML +=  '';
            document.querySelector('.size-discount__item--unit_price').innerHTML +=  '';
            
              console.error('Error occurred:', error);
          }
      });
      }
      
    function availvariants(){
        var short = document.querySelector('#length-drop');
        var long = document.querySelector('#height-drop');
        var width = document.querySelector('#width-drop');
        var productHandle = short.value + "x" + long.value + "x" + width.value;
        productHandle = productHandle.replace(/\s+/g, '-');
        productHandle = productHandle.replace(/\//g, '-');
        if (productHandle == "16-3-8x21-1-2x1" || productHandle == "13x21-1-2x1" || productHandle == "19-7-8x21-1-2x1" || productHandle == "21-1-2x23-5-16x1"){
          
          productHandle += "-carrier-replacement-filter-by-aerostar";
          console.log(productHandle);
        }

else if( productHandle == "17x27x5" || productHandle == "21x26x5"){

 productHandle += "-trane-deep-pleat-air-filter";
}
else if( productHandle == "19x20x4"){

 productHandle += "-carrier-deep-pleat-air-filter"; }    else if(productHandle == "16x20x4" || productHandle == "16x24x4" || productHandle == "18x24x4" || productHandle == "20x24x4" || productHandle == "20x25x4" || productHandle == "24x24x4" ){  productHandle += "-commercial-hvac-filter"; }        else if(productHandle == "16x20x5"){  productHandle += "-honeywell-deep-pleat-air-filter";
}
        else {
  
          productHandle += "-air-filter";
          console.log(productHandle);
        }
        $.ajax({
          url: `${shopifyStoreUrl}/api/2024-10/graphql.json`,  // Replace with your Shopify store's URL
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
              query: `
                  {
                      product(handle: "` + productHandle + `") {
                                  title
                                  variants(first: 30) {
                                    edges {
                                      node {
                                        id
                                        title
                                        priceV2{
                                        amount
                                        }
                                        availableForSale
                                        quantityAvailable
                                        selectedOptions {
                                          name
                                          value
                                        }                            
                                      }
                                    }
                                  }
                                }
                  }
              `,
          }),
             headers: {
                      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                  },
          success: function(response) {
            document.getElementById('merv6con').style.display = 'none';
            document.getElementById('merv8con').style.display = 'none';
            document.getElementById('merv11con').style.display = 'none';
            document.getElementById('carboncon').style.display = 'none';
            document.getElementById('merv13con').style.display = 'none';
            const products = response.data.product.variants.edges;
            var origprice = 0;
            console.log(products);
            products.forEach(function (product) {
               console.log(product.node.selectedOptions[1].value, product.node.selectedOptions[0].value);
               if (product.node.selectedOptions[1].value == packSize){
               
                        if (product.node.selectedOptions[0].value == 'MERV 8' && product.node.quantityAvailable > 0){
                  
                  
                          document.getElementById('merv8con').style.display = '';
                  
                        }
                        if (product.node.selectedOptions[0].value == 'MERV 6' && product.node.quantityAvailable > 0){
                      
                          document.getElementById('merv6con').style.display = '';
                        }
                        if (product.node.selectedOptions[0].value == 'MERV 11' && product.node.quantityAvailable > 0){
                   
                          document.getElementById('merv11con').style.display = '';
                     
                        }
                        if (product.node.selectedOptions[0].value == 'MERV 13' && product.node.quantityAvailable > 0){
                        
                          document.getElementById('merv13con').style.display = '';
                        }
                        if (product.node.selectedOptions[0].value == 'MERV 11 + Carbon' && product.node.quantityAvailable > 0){
                  
                          document.getElementById('carboncon').style.display = '';
                        }
               }
              });
      
          
                },
          error: function(error) {

          }
      });
      }
      
    